module.exports = __webpack_public_path__ + "static/img/practical_post.ff36f16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/question/practical_post.jpg
// module id = M+Ui
// module chunks = 1